// BlockType > BlockType
import { IBlockType } from './IBlockType'

export default class BlockType<P> implements IBlockType<P> {
	constructor(private readonly _label: string, private readonly _color: string, private readonly _resource: P) {}

	get label() {
		return this._label
	}

	get color() {
		return this._color
	}

	get resource(): P {
		return this._resource
	}
}
